<template>
  <div v-if="!loading">
    <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                    :sticky-datas="stickyDatas" :reload-controls="loading && sentItems.length">
      <table v-show="!loading && sentItems.length"
             class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
        <thead>
        <tr class="is-size-6">
          <th class="is-paddingless has-text-centered actions" style="z-index:2;">
            <div class="dropdown is-hoverable is-left">
              <div class="dropdown-trigger">
                <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                  <i class="fal fa-cog"></i>
                </button>
              </div>
              <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
            </div>
          </th>
          <th>
            Date
          </th>
          <th>
            Type
          </th>
          <th>
            Participant
          </th>
          <th>
            Contact
          </th>
          <th v-if="showColumn('guest')">
            Invité(s)
          </th>
          <th v-if="showColumn('author')">
            Organisateur
          </th>
          <th>
            Bilan
          </th>
          <th class="has-text-centered"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(rdv, index) in sentItems" :key="rdv.pk" class="is-size-6" :id="'e' + rdv.pk"
            :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === rdv.pk}">
          <td class="has-text-centered">
            <span v-if="rdv.successful" class="dot tooltip is-tooltip-right has-bg-success"
                  data-tooltip="Effectué"></span>
            <span v-else-if="rdv.deferred" class="dot tooltip is-tooltip-right has-bg-warning"
                  data-tooltip="Reporté"></span>
            <span v-else-if="rdv.canceled" class="dot tooltip is-tooltip-right has-bg-danger"
                  data-tooltip="Annnulé"></span>
            <span v-else></span>
          </td>
          <td class="is-cell-hoverable">
            <a @click="goToDay(rdv.date, true)">
              {{rdv.date|dateList}}
            </a>
          </td>
          <td>
            {{rdv.rdv_type}}
          </td>
          <td class="is-cell-hoverable">
            <router-link class="is-cell-hoverable"
                         :to="{name: 'UserVue', params: {id: rdv.seller}, query: {returnId: rdv.pk}}">
              {{rdv.seller_name}}
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'ContactVue', params: {id: rdv.contact}, query: {returnId: rdv.pk}}">
              {{rdv.contact_name}}
            </router-link>
          </td>
          <td v-if="showColumn('guest')">
            <span v-for="(guest, i) in rdv.guests_name" :key="guest">
              <span>{{guest}}</span>
              <span v-if="i + 1 < rdv.guests_name.length"> - </span>
            </span>
          </td>
          <td v-if="showColumn('author')" class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: rdv.author}, query: {returnId: rdv.pk}}">
              {{rdv.author_name}}
            </router-link>
          </td>
          <td>
            <span>

            </span>
            <span v-if="rdv.reports[0]">
              {{calendarType(rdv.reports[0].type)}}
            </span>
            <span v-if="rdv.reports[1]">
              - {{calendarType(rdv.reports[0].type, rdv.reports[1].type)}}
            </span>
          </td>
          <td class="has-text-centered actions">
            <display-button-list :forceDropDown="true" :buttons="buttonList" :data="rdv"
                                 :openUp="{'position': index, 'total': sentItems.length}">
            </display-button-list>
          </td>
        </tr>
        <tr class="empty empty--row" v-for="n in sentItems.length < 4 ? 4 - sentItems.length : 0 " :key="n"><td class="is-borderless"></td></tr>
        </tbody>
      </table>
    </table-h-scroll>
    <div v-show="!loading && !sentItems.length" class="is-border-top">
      <div class="columns">
        <div class="column">
          <h2 class="title is-3 has-text-weight-bold">Aucun rendez-vous programmé</h2>
        </div>
      </div>
    </div>
    <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
      <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
        <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
        <span class="is-size-6">Afficher la suite</span>
      </a>
      <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
    </div>
  </div>
</template>

<script>
  import { Sort, ColumnConf, TableHeaderSticky } from '@/mixins'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'CalendarListRdv',
    mixins: [Sort, ColumnConf, TableHeaderSticky],
    props: {
      sentItems: Array,
      loading: Boolean,
      totalPage: Number,
      nextPage: Number
    },
    data () {
      return {
        columnsConfResource: 'rendez-vous',
        sortBy: {},
        buttonList: [
          {
            action: (id, data) => {
              let day = moment(data.date).format('DD')
              let month = moment(data.date).format('MM')
              let year = moment(data.date).format('YYYY')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, returnId: data.pk } })
            },
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            action: (id, data) => {
              let params = {
                source: data
              }
              this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION', params: params})
            },
            icon: 'fa-edit',
            text: 'Editer'
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            text: 'Supprimer'
          }
        ]
      }
    },
    filters: {
      dateList: function (value) {
        return moment(value).format('DD/MM/YYYY HH:mm')
      }
    },
    computed: {
      ...mapState(['scrollToEl', 'scrollToPage']),
      columnsShow () {
        const columns = {
          'guest': { label: 'Invité(s)', mobile: true },
          'author': { label: 'Organisateur', mobile: true }
        }
        return columns
      }
    },
    methods: {
      deleteItem (i) {
        this.$emit('deleteItem', i)
      },
      loadMore (val) {
        this.$emit('loadMore', val)
      },
      goToDay (e) {
        let date = moment(e)
        let day = date.get('date')
        let month = date.get('month')
        month = month + 1
        let year = date.get('year')
        this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
      },
      calendarType (n1, n2 = false) {
        let calendar = [
          {
            'type': 'interested',
            'label': 'Intéressé',
            'children': [
              {
                'type': 'new_rdv',
                'label': 'Nouveau rdv',
                'action': 'new_rdv'
              },
              {
                'type': 'delay',
                'label': 'À suivre'
              },
              {
                'type': 'set_visit',
                'label': 'Plannifier visite',
                'action': 'new_rdv'
              },
              {
                'type': 'signing',
                'label': 'Signature',
                'action': 'new_rdv'
              }
            ]
          },
          {
            'type': 'not_interested',
            'label': 'Pas intéressé'
          },
          {
            'type': 'wrong_target',
            'label': 'Hors cible',
            'children': [
              {
                'type': 'taxes',
                'label': 'Imposition'
              },
              {
                'type': 'age',
                'label': 'Âge'
              },
              {
                'type': 'time',
                'label': 'Période'
              },
              {
                'type': 'funding',
                'label': 'Financement'
              },
              {
                'type': 'no_offer',
                'label': 'Pas d\'offre'
              },
              {
                'type': 'other',
                'label': 'Autre'
              }
            ]
          }
        ]
        let reportN1
        let reportN2
        reportN1 = calendar.find(x => x.type === n1)
        if (!n2) {
          return reportN1.label
        } else {
          reportN2 = reportN1.children.find(x => x.type === n2)
          return reportN2.label
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarListRdv.vue